import { useCallback } from "react";
import useLabData from "./useLabData";
import useSceneData from "./useSceneData";

export default function useCalcFitToSide() {
    const labData = useLabData();
    const sceneData = useSceneData();

    return useCallback((layerWidth:number, layerHeight:number, side:'left'|'right'|'top'|'bottom') => {
        if(!labData || !sceneData) {
            return {
                x: 0,
                y: 0,
                scaleX: 1,
                scaleY: 1,
                rotation: 0,
            }
        }

        const listParts = Object.keys(sceneData.parts);
        const part = listParts.length > 1 ? side : listParts[0];
        const outputType = 'lab';
        let rotation = 0;

        if(labData.fit_rotate){
            if(side === "left") rotation = -90;
            else rotation = 90;
        }
    
        const x = sceneData.parts[part][outputType].x;
        const y = sceneData.parts[part][outputType].y;
        const width = sceneData.parts[part][outputType].width;
        const height = sceneData.parts[part][outputType].height;

        // Fit exact bounds while preserving the image ratio and side rotation.
        const rotated = Math.abs(rotation) === 90;
        const imageWidth = rotated ? layerHeight : layerWidth;
        const imageHeight = rotated ? layerWidth : layerHeight;
        let scale = Math.max(width / imageWidth, height / imageHeight);

        // Round up only if floating-point multiplication leaves an edge short.
        if(imageWidth*scale < width || imageHeight*scale < height) {
            scale += scale * Number.EPSILON;
        }

        return {
            x: x + width / 2,
            y: y + height / 2,
            scaleX: scale,
            scaleY: scale,
            rotation,
        }
    }, [labData, sceneData]);
}